<template>
    <rkm-layout-body title="Lista de pacientes">
        <rkm-layout-content>
            <List />
        </rkm-layout-content>
    </rkm-layout-body>
</template>

<script>

// Components.
import List from '@/components/regulacao/solicitacao/List'

export default {
    components: { List },
}
</script>